/* eslint-disable no-nested-ternary */
import { Stack, Typography } from '@mui/material';
import parse from 'html-react-parser';
import { ResponsiveText, responsiveTextParseOptions } from '@treedis/tour-loader';

const info = [
  { property: 'accomodation', description: 'Accomodation<br />Type' },
  { property: 'size', description: 'Property Size' },
  { property: 'beds', description: 'Number of<br />Rooms' },
  { property: 'cars', description: 'Number of<br />Parking places' },
  { property: 'showers', description: 'Bathrooms' },
  { property: 'price', description: 'Price' },
];

type Props = {
  text?: string;
  tour: {
    [key: string]: string | number | null;
    unitSystem?: 'metric' | 'imperial';
    id?: string;
    translation?: any;
  };
};

const getProperty = (tour: Props['tour'], item: { property: string }) => {
  if (!item?.property) return null;
  const { property } = item;
  const propertyValue = tour[property];

  return property === 'size' ? `${propertyValue} ${tour.unitSystem === 'metric' ? 'm&#178;' : 'ft&#178;'}` : propertyValue;
};

export function Description({ text, tour }: Props) {
  if (!tour) return null;

  return (
    <Stack spacing={2}>
      {text && (
        <>
          <Typography variant="h5">{tour?.translation?.description || 'Description'}</Typography>
          <ResponsiveText>{parse(text, responsiveTextParseOptions)}</ResponsiveText>
        </>
      )}
      <Stack direction="row" flexWrap="wrap" ml="-16px !important">
        {info.map((item, index) =>
          tour[item.property] ? (
            <Stack key={`${tour.id}-${item.property}-${index}`} spacing={1} sx={{ my: 1, mx: 2 }}>
              <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                {parse(`${getProperty(tour, item) || ''}`)}
              </Typography>

              <Typography
                variant="body2"
                component="span"
                sx={{
                  color: 'text.secondary',
                  lineHeight: '15px',
                }}
              >
                {parse(item.description)}
              </Typography>
            </Stack>
          ) : null,
        )}
      </Stack>
    </Stack>
  );
}
